import type { DeviceStorage } from '@puzzlio/core';

/** The browser's storage for the shared logic that takes one: localStorage, wrapped to the shared interface. */
export const deviceStorage: DeviceStorage = {
  get: (key) => localStorage.getItem(key),
  set: (key, value) => localStorage.setItem(key, value),
  remove: (key) => localStorage.removeItem(key),
  keys: () => Object.keys(localStorage),
};
